module.exports = __webpack_public_path__ + "static/media/goldenprize-sardine-naturalChili.56f2c09f.png";